<template>
  <div class="data-preview">
    <h2 v-if="title">{{ title }}</h2>
    <ol class="list-group" v-for="(item, index) in items" :key="index">
      <li class="list-group-item">
        <div v-for="(value, key) in item" :key="key">
          <b>{{ key }}</b>: {{ value }}
        </div>
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: "DataPreview",
  props: {
    title: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.data-preview h2 {
  margin-bottom: 0.75rem;
}
</style>
